var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKaWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#fff;}.cls-4{fill:#eff2fa;}.cls-5{fill:#32393f;}.cls-6{fill:#575f64;}.cls-7{fill:#00aadf;}.cls-8{fill:#007a9f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.96,
    y: 20.94,
    width: 144,
    height: 118.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Maske"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 160,
    height: 160,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.12,
    y: 20.94,
    width: 8.44,
    height: 63.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 126.37,
    y: 20.94,
    width: 8.44,
    height: 63.28
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 117.93,
    y: 80,
    width: 25.31,
    height: 21.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 16.68,
    y: 80,
    width: 25.31,
    height: 21.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 7.96,
    y: 96.87,
    width: 144,
    height: 42.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 79.96,
    y: 96.87,
    width: 72,
    height: 42.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M119.7,51.9l-7.17,4.39a37.94,37.94,0,0,0-65.14,0L40.22,51.9a46.31,46.31,0,0,1,79.48,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.28,60.59,98,64.9a21.07,21.07,0,0,0-36.11,0l-7.26-4.31a29.51,29.51,0,0,1,50.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.85,69.28l-7.26,4.31a4.47,4.47,0,0,0-7.26,0l-7.25-4.31a12.71,12.71,0,0,1,21.77,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 101.06,
    y: 113.75,
    width: 25.31,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 67.31,
    y: 113.75,
    width: 8.44,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 50.43,
    y: 113.75,
    width: 8.44,
    height: 8.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 33.56,
    y: 113.75,
    width: 8.44,
    height: 8.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M83.59,73.59A4.12,4.12,0,0,0,80,71.73v-8.6a12.83,12.83,0,0,1,10.89,6.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80,54.69V46.25a29.68,29.68,0,0,1,25.32,14.34L98,64.9A21.32,21.32,0,0,0,80,54.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80,37.81V29.37A46.52,46.52,0,0,1,119.7,51.9l-7.17,4.39A38.2,38.2,0,0,0,80,37.81Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaWifi);
export default __webpack_public_path__ + "static/media/ka_wifi.409b2583361825367004b233d5291874.svg";
export { ForwardRef as ReactComponent };